var map = {
	"./back-dark.svg": 127,
	"./disableFullScreen-dark.svg": 128,
	"./download-grey.svg": 234,
	"./download.svg": 235,
	"./enableFullScreen-dark.svg": 129,
	"./info-grey.svg": 236,
	"./info.svg": 237,
	"./mobile.svg": 130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;